<div class="container-banner-license" *ngIf="isActiveBannerLicense">
    <div class="banner">
        <img class="icon" appImageSelector alt="mt-image-warning" imageType="icon" imageKey="warning-icon">&nbsp;
        <span class="text-banner">Recordatorio : Su licencia ha expirado. Favor comunicarse a contacto@miningtag.com</span>
    </div>
</div>
